import { render, staticRenderFns } from "./Community.vue?vue&type=template&id=18299a6c&scoped=true&"
import script from "./Community.vue?vue&type=script&lang=js&"
export * from "./Community.vue?vue&type=script&lang=js&"
import style0 from "./Community.vue?vue&type=style&index=0&id=18299a6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18299a6c",
  null
  
)

export default component.exports